// $ = window.$;

import axios from "axios";

class ImageUploader {
    constructor(imageUploader) {
        this.imageUploader = imageUploader;
        this.dndZone = imageUploader.querySelector('.dnd-zone');
        this.deleteForm = imageUploader.querySelector('.delete-form');
        this.uploadForm = imageUploader.querySelector('.upload-form');
        this.fileField = this.uploadForm.querySelector('.image-upload-control');
        this.image = imageUploader.querySelector('div.image-zone img.image');

        this.dndZoneHandler = this.dndZoneHandler.bind(this);
        this.fileSelectHandler = this.fileSelectHandler.bind(this);
        this.deleteHandler = this.deleteHandler.bind(this);

        this.popover = bootstrap.Popover.getInstance(this.dndZone);
        this.dndZone.addEventListener('inserted.bs.popover', () => {
            console.log('inserted.bs.popover');
            this.bindAll();
        });
        this.dndZone.addEventListener('hide.bs.popover', () => {
            console.log('hide.bs.popover');
            this.unbindAll();
        });

        document.querySelector('body').addEventListener('click', function(){
            this.popover.hide();
        }.bind(this));

        this.fileField.addEventListener('change', function(){
            this.upload();
        }.bind(this));
    }
    unbindAll(){
        this.dndZone.addEventListener('click', this.dndZoneHandler);
        this.imageUploader.querySelector('.show-file-select').removeEventListener('click', this.fileSelectHandler);

        this.imageUploader.querySelector('.delete').removeEventListener('click', this.deleteHandler);
    }

    bindAll(){
        this.dndZone.removeEventListener('click', this.dndZoneHandler);
        this.imageUploader.querySelector('.show-file-select').addEventListener('click', this.fileSelectHandler);

        if (this.image.getAttribute('src') === '/images/avatar-blank.png'){
            this.imageUploader.querySelector('.delete').classList.add('d-none');
        } else {
            this.imageUploader.querySelector('.delete').addEventListener('click', this.deleteHandler);
        }
    }

    delete(){
        this.dndZone.classList.remove('dragover');
        let url = this.deleteForm.getAttribute('action');
        let formData = new FormData(this.deleteForm);


        axios
            .post(url, formData)
            .then(response => {
                if (response.data.result === 'OK'){
                    this.image.setAttribute('src', '/images/avatar-blank.png');
                    toastr.success('画像を削除しました');
                } else if (response.result === 'ERROR'){
                    toastr.error(response.data.error);
                }
            });
    }

    upload(files){
        this.dndZone.classList.remove('dragover');
        let url = this.uploadForm.getAttribute('action');
        this.fileField.removeEventListener('change', this.upload);

        let formData;
        if (files){
            formData = new FormData(this.uploadForm);
            formData.append('file', files[0]);
        } else {
            formData = new FormData(this.uploadForm);
        }

        axios
            .post(url, formData)
            .then(response => {
                if (response.data.result === 'OK'){
                    const timestamp = new Date().getTime();
                    this.image.setAttribute('src', response.data.data.url + '?t=' + timestamp);
                    toastr.success('画像をアップロードしました');
                } else if (response.result === 'ERROR'){
                    toastr.error(response.data.error);
                }
            });

        /*
        $.ajax({
            type: 'POST',
            url: url,
            data: formData,
            processData: false,
            contentType: false
        }).done(function(response){
            if (response.result === 'OK'){
                this.image.setAttribute('src', response.data.url + '?' + (new Date()).getTime());
                toastr.success('画像をアップロードしました');
            } else if (response.result === 'ERROR'){
                toastr.error(response.data.error);
            }
        }.bind(this));

         */
    }

    fileSelectHandler(e){
        e.preventDefault();
        this.popover.hide();
        this.fileField.click();
    }
    deleteHandler(e){
        if (confirm('画像を削除します。よろしいですか？')){
            this.delete();
        }
    }
    cancelHandler(e){
        this.popover.hide();
    }
    dndZoneHandler(e){
        e.stopPropagation();
        this.popover.show();
    }
}

document.addEventListener('DOMContentLoaded', function(){
    let imageUploaders = document.querySelectorAll('.image-uploader');
    if (imageUploaders.length > 0) {
        [...imageUploaders].forEach(element => {
            let imageUploader = new ImageUploader(element);

            imageUploader.dndZone.addEventListener('click', imageUploader.dndZoneHandler);
            imageUploader.dndZone.addEventListener('dragover', (e) => {
                e.preventDefault();
                imageUploader.dndZone.classList.add('dragover');
            });
            imageUploader.dndZone.addEventListener('dragleave', (e) => {
                e.preventDefault();
                imageUploader.dndZone.classList.remove('dragover');
            });
            imageUploader.dndZone.addEventListener('drop', (e) => {
                e.preventDefault();
                imageUploader.dndZone.classList.remove('dragover');

                let files = e.dataTransfer.files;
                imageUploader.upload(files);
            });
        });
    }
});
